import { ListItem, Flex, IconButton, Link } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Item } from "./types/item";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import { supabase } from "index";

type SowFileTemplateProps = {
  item?: Item;
};

export const SowFileTemplate = ({ item }: SowFileTemplateProps) => {
  const { user } = useTenant();
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!isApplicable(item)) {
      return;
    }

    const fetchUrl = async () => {
      const { data } = await supabase.storage.from("templates").createSignedUrl(
        `${user?.lender_company?.id}/checklist_items_defaults/SOW + Draw Req Template.xlsx`,
        60 * 60 * 24 // 1 day
      );

      setUrl(data?.signedUrl);
    };

    fetchUrl();
  }, [user, item]);

  if (!url) {
    return null;
  }

  return (
    <ListItem py="12px" borderColor="gray.50" borderBottomWidth="1px">
      <Flex justifyContent="space-between" fontSize="14px" alignItems="center">
        <Link target="_blank" href={url}>
          SOW + Draw Req Template.xlsx
        </Link>
        <Flex alignItems="center">
          <Text>185.4KB</Text>
          <IconButton
            disabled={true}
            width="9px"
            height="9px"
            aria-label="remove-file"
            variant="ghost"
            title="This file cannot be removed"
            icon={<FontAwesomeIcon icon={["fal", "times"]} />}
          />
        </Flex>
      </Flex>
    </ListItem>
  );
};

export function isApplicable(item: Item | undefined): boolean {
  if (!item) {
    return false;
  }

  return (
    item.category === "SOW" &&
    item.type === "tasks" &&
    item.title === "Rehab Budget Correctly Input into Sizer"
  );
}
